import { jsx as _jsx } from "react/jsx-runtime";
import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { getSearchMenuOmittedModes, SEARCH_MODES, } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/mode-toggle-constants.js';
import { ComputerCommandMenuSkeleton } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/ComputerCommandMenuSkeleton.js';
import { useComputerCommandMenuUiActionSelect } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/useComputerCommandMenuUiActionSelect.js';
import { useAskInputActions } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputProviderShared.js';
import { useOpenConnectorModalBySourceId } from '#pplx/frontend/apps/ask/connectors/modal-navigation/useOpenConnectorModalBySourceId.js';
import { SearchModeMenuItems } from '#pplx/frontend/apps/ask/search-modes-menu/SearchModeMenuItems.js';
import { useVisibleSearchModes } from '#pplx/frontend/apps/ask/search-modes-menu/useVisibleSearchModes.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useMemo } from 'react';
const ComputerModeMenuItems = Dynamic(async () => {
    const { ComputerModeMenuItems } = await import('#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/ComputerModeMenuItems.js');
    return { default: ComputerModeMenuItems };
});
const ComputerCommandMenuItems = Dynamic(async () => {
    const { ComputerModeMenuItems } = await import('#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/index.js');
    return { default: ComputerModeMenuItems };
}, { loading: ComputerCommandMenuSkeleton });
export function useAskInputModeToggleGroupRenderMenu({ searchModeControllerProps, computerModeMenuVariant, showComputerSkillsDropdown = false, skillMentionEditorRef, collectionUuid, isFollowUp = false, computerCommandMenuSearchQuery, sideChatAvailable = false, onSideChatCommandSelect, registerInputKeyDownHandler, hideCommandItems = false, hideSettingsAction = false, onOpenSettings, }) {
    const { openModal } = useModalContext();
    const openConnectorModal = useOpenConnectorModalBySourceId({
        reason: 'skill-modal-connector',
        openModal,
    });
    const { onActiveMenuChange } = useAskInputActions();
    const activeSearchMode = searchModeControllerProps.showSearchMode
        ? searchModeControllerProps.searchMode
        : SearchMode.SEARCH;
    const rawOmittedSearchModes = searchModeControllerProps.showSearchMode
        ? searchModeControllerProps.omittedSearchModes
        : undefined;
    const searchMenuOmittedModes = useMemo(() => getSearchMenuOmittedModes({
        omittedSearchModes: rawOmittedSearchModes ?? EMPTY_ARRAY,
        modes: SEARCH_MODES,
    }), [rawOmittedSearchModes]);
    const visibleSearchModes = useVisibleSearchModes({
        omittedSearchModes: searchMenuOmittedModes,
    });
    const isSidecarBuild = !!import.meta.env.VITE_IS_SIDECAR_BUILD;
    const hasAlternativeSearchMode = visibleSearchModes.some((mode) => mode.id !== activeSearchMode);
    const resolvedComputerModeMenuVariant = computerModeMenuVariant ?? (showComputerSkillsDropdown ? 'skills' : 'none');
    const handleComputerCommandMenuUiActionSelect = useComputerCommandMenuUiActionSelect({
        computerCommandMenuSearchQuery,
        isFollowUp,
        onActiveMenuChange,
        onSideChatCommandSelect,
        searchModeControllerProps,
    });
    return useMemo(() => {
        if (searchModeControllerProps.showSearchMode && SEARCH_MODES.includes(activeSearchMode)) {
            if (isSidecarBuild && !hasAlternativeSearchMode) {
                return null;
            }
            const { searchMode, onSearchModeSelect } = searchModeControllerProps;
            return () => (_jsx(SearchModeMenuItems, { searchMode: searchMode, onSearchModeSelect: onSearchModeSelect, omittedSearchModes: searchMenuOmittedModes, primaryModes: SEARCH_MODES }));
        }
        if (activeSearchMode === SearchMode.ASI && resolvedComputerModeMenuVariant === 'skills') {
            return ({ closeMenu }) => (_jsx(ComputerModeMenuItems, { collectionUuid: collectionUuid, skillMentionEditorRef: skillMentionEditorRef, onMenuClose: closeMenu }));
        }
        if (activeSearchMode === SearchMode.ASI && resolvedComputerModeMenuVariant === 'command') {
            return ({ closeMenu }) => (_jsx(ComputerCommandMenuItems, { collectionUuid: collectionUuid, skillMentionEditorRef: skillMentionEditorRef, isFollowUp: isFollowUp, searchQuery: computerCommandMenuSearchQuery, sideChatAvailable: sideChatAvailable, registerInputKeyDownHandler: registerInputKeyDownHandler, appOpenModal: openModal, openConnectorModal: openConnectorModal, onUiActionSelect: (actionId) => handleComputerCommandMenuUiActionSelect(actionId, closeMenu), onMenuClose: closeMenu, hideCommandItems: hideCommandItems, hideSettingsAction: hideSettingsAction, onOpenSettings: onOpenSettings }));
        }
        return null;
    }, [
        activeSearchMode,
        collectionUuid,
        computerCommandMenuSearchQuery,
        handleComputerCommandMenuUiActionSelect,
        hasAlternativeSearchMode,
        hideCommandItems,
        hideSettingsAction,
        isFollowUp,
        isSidecarBuild,
        onOpenSettings,
        openModal,
        openConnectorModal,
        registerInputKeyDownHandler,
        resolvedComputerModeMenuVariant,
        searchModeControllerProps,
        searchMenuOmittedModes,
        sideChatAvailable,
        skillMentionEditorRef,
    ]);
}
//# sourceMappingURL=useAskInputModeToggleGroupRenderMenu.js.map